import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AnalyticsProvider } from '@vaptmenu/analytics-react'
import './shared/styles/global.css'
import { AppProviders } from './app/providers/AppProviders'
import { PanelFeatureFlagsProvider } from './app/providers/PanelFeatureFlagsProvider'
import { AnalyticsIdentitySync } from './app/providers/AnalyticsIdentitySync'
import { IconDefaults } from './app/providers/IconDefaults'
import { ToastContainer } from './shared/components/Toast'
import App from './App.tsx'

// Só `VITE_MSW=true` liga os mocks: a env chega como string, e "false" também é truthy.
const mswEnabled = import.meta.env.VITE_MSW === 'true';

async function enableMocking() {
  if (import.meta.env.MODE !== 'development' || !mswEnabled) {
    return;
  }

  const { worker } = await import('./mocks/browser');
  return worker.start({
    onUnhandledFrame: 'bypass',
  });
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AnalyticsProvider
        config={{
          apiKey: import.meta.env.VITE_POSTHOG_KEY,
          app: 'panel',
          environment: import.meta.env.VITE_APP_ENV,
          release: import.meta.env.VITE_APP_RELEASE,
          privacyProfile: 'authenticated-b2b',
          disabled: mswEnabled,
        }}
      >
        <AnalyticsIdentitySync />
        <PanelFeatureFlagsProvider>
          <AppProviders>
            <IconDefaults>
              <App />
              <ToastContainer />
            </IconDefaults>
          </AppProviders>
        </PanelFeatureFlagsProvider>
      </AnalyticsProvider>
    </StrictMode>,
  );
});
